import { jsx as _jsx } from "react/jsx-runtime";
import { CarInfoSummary } from "./CarInfoSummary";
import { identityRecordOfFieldEditorOptions } from "@ploy-ui/form-fields";
const carSummaryVariants = ["small"];
export const CarSummaryField = (props) => {
    const { variant } = props;
    switch (variant) {
        case "small":
            return _jsx(CarInfoSummary, { ...props, small: true });
        default:
            return _jsx(CarInfoSummary, { ...props });
    }
};
export const EditorCarSummaryFields = identityRecordOfFieldEditorOptions({
    CarSummaryField: {
        editableOptions: {
            variant: carSummaryVariants
        }
    }
});
//# sourceMappingURL=CarSummaryField.js.map